<!--
 * @Author: Merlin
 * @Date: 2024-11-12 16:54:27
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-02 10:36:21
 * @Description: 
-->
<template>
    <div
        class="history-bar w-full relative"
    >
        <ClientOnly>
            <ul class="relative inset-0 gap-2 overflow-hidden inline-flex justify-end shadow mt-4"
                v-if="aHistoryToShow.length > 0"
            >
                <li
                    v-for="(oHistory, idx) of aHistoryToShow"
                    :key="idx"
                    class="min-w-[50px] h-5 flex items-center text-xs rounded-lg font-semibold justify-center leading-22"
                    :class="[oHistory.sType]"
                >
                    {{ oHistory.sVal }}
                </li>
            </ul>
        </ClientOnly>
    </div>
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import { useGameHistoryStore } from '~/stores/cansino/gameHistory';
import { useJoinStateStore } from '~/stores/cansino/joinState';


const t = useTranslation();
const gameHistoryStore = useGameHistoryStore();
const userStore = useUserStore();
const joinStateStore = useJoinStateStore();
const aHistoryToShow = computed(() => {
    if (!userStore.isLoggedIn) return [];
    // ↓ 取最新的 10 条数据（延时的数据） 
    const aArr = gameHistoryStore.gameHistoryDelay.response
        .slice(0, 15)
        .reverse();
    const aResult = (aArr || []).map((cur) => {
        const [gameValue] = cur.randomSeed?.split?.('_');
        const oThisOne = {
            iVal: gameValue,
            sVal: gameValue,
            sType: (() => {
                if (cur.winAmount > 0) {
                    return 'bg-[#24E34DFF] text-[#1C2532FF]';
                }
                return 'bg-[#00234EFF] text-[#4d75a6]';
            })(),
        };
        return oThisOne;
    });
    return aResult;
});
</script>


<style scoped>
.history-bar{
    margin-bottom: 15px;
    overflow: hidden;
    display: flex;
    ul{
        display: flex;
        width: 0;
        flex: 1 1 auto;
    }
}

.shadow::after {
    content: '';
    background: linear-gradient(90deg, #01336c, rgba(1, 51, 108, 0));
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 40px;
    height: 20px;
}

</style>
